import React from "react";
import { useFieldArray, useWatch } from "react-hook-form";
import { StyledWrapper } from "./feedbackTagsFields.style";
import FeedbackTag from "./feedbackTag.component";

const FeedbackTagsFields = ({ name, settings = {} }) => {
  const { append, fields } = useFieldArray({ name, keyName: "_id" });
  const watchArray = useWatch({ name });

  const lastVisibleIndex = watchArray.findLastIndex((item) => !item._destroy);
  return (
    <StyledWrapper>
      {fields.map((field, index) => (
        <FeedbackTag
          key={field._id}
          index={index}
          parentName={name}
          settings={settings}
          values={field}
          readOnly={index < 8}
          lastVisibleIndex={lastVisibleIndex}
          append={append}
        />
      ))}
    </StyledWrapper>
  );
};

export default FeedbackTagsFields;
